import { styled, Tooltip, tooltipClasses } from '@mui/material';

export const HtmlTooltip = styled(({ className, ...props }) => (
  <Tooltip {...props} classes={{ popper: className }} />
))(({ theme }) => ({
  [`& .${tooltipClasses.tooltip}`]: {
    backgroundColor: '#ffffff',
    color: 'rgba(0, 0, 0, 0.87)',
    boxShadow: '0px 0px 5px 0px #8e8e8e',
    width: 340,
  },
}));
